import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated, getCurrentUser } from '../services/authService'; // Importiere die asynchrone Funktion
import { Spin } from 'antd';

// Diese Komponente prüft asynchron, ob der Benutzer eingeloggt UND Admin ist.
const AdminRoute = () => {
    const [isAdmin, setIsAdmin] = useState(null); // null = loading, true = admin, false = not admin/not logged in
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAdminStatus = async () => {
            setIsLoading(true);
            try {
                const isAuth = await isAuthenticated(); // Prüft, ob Token gültig ist
                if (!isAuth) {
                    console.log('AdminRoute: Nicht authentifiziert.');
                    setIsAdmin(false);
                    return;
                }
                
                const user = await getCurrentUser(); // Holt Benutzerdaten
                if (user && user.role === 'admin') {
                    console.log('AdminRoute: Benutzer ist Admin.');
                    setIsAdmin(true);
                } else {
                    console.log(`AdminRoute: Benutzer ist ${user?.role || 'unbekannt'}, aber kein Admin.`);
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error('AdminRoute: Fehler bei der Prüfung des Admin-Status:', error);
                setIsAdmin(false); // Bei Fehler Zugriff verweigern
            } finally {
                setIsLoading(false);
            }
        };

        checkAdminStatus();
    }, []);

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <Spin tip="Prüfe Berechtigung..." size="large" />
            </div>
        );
    }

    if (isAdmin === true) {
        // Wenn Admin, die Kind-Route rendern
        return <Outlet />;
    } else if (isAdmin === false) {
        // Wenn kein Admin oder nicht eingeloggt, zur Startseite umleiten
        // TODO: Evtl. zum Login umleiten, wenn !isAuthenticated? Hängt vom Auth-Flow ab.
        return <Navigate to="/" replace />;
    } else {
        // Sollte nicht passieren, aber als Fallback
         return <Navigate to="/" replace />;
    }
};

export default AdminRoute; 